/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module MatchModule */

import {
    Component,
    Input,
} from '@angular/core';

import {
    ProtocolMatchConfigItem,
} from 'ajs/modules/match/factories/protocol-match.config-item.factory';

import {
    L4RuleProtocolMatchConfigItem,
} from 'ajs/modules/l4-policy/factories/matches/l4-rule-protocol-match.config-item.factory';

import { L10nService } from '@vmw/ngx-vip';
import { SchemaService } from 'ajs/modules/core/services';
import * as globalL10n from 'global-l10n';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description
 *     Readonly match component for the ProtocolMatch and L4RuleProtocolMatch message.
 * @author Rohit Gaikwad
 */
@Component({
    selector: 'protocol-type-match-readonly',
    templateUrl: './protocol-type-match-readonly.component.html',
})
export class ProtocolTypeMatchReadonlyComponent {
    /**
     * Protocol message item instance.
     */
    @Input()
    public editable: ProtocolMatchConfigItem | L4RuleProtocolMatchConfigItem;

    /**
     * objectType passed to the MatchWrapperComponent.
     */
    @Input()
    public objectType: string;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(
        l10nService: L10nService,
        private readonly schemaService: SchemaService,
    ) {}
    /**
     * Convenience method to get text label for selected protocol type.
     */
    public get protocolType(): string {
        let ngModelFieldName = 'protocols';

        if (this.objectType === 'L4RuleMatchTarget') {
            ngModelFieldName = 'protocol';
        }

        return this.schemaService.getEnumValueLabel(
            this.objectType,
            this.editable.config[ngModelFieldName],
        );
    }

    /**
     * Convenience method to get text label for selected match criteria.
     */
    public get matchCriteria(): string {
        return this.schemaService.getEnumValueLabel(
            'MatchOperation',
            this.editable.config.match_criteria,
        );
    }
}
